<template>
  <div class="register">
    <div id="nav" class="header">
      <head-top></head-top>
    </div>
    <div class="main">
      <register></register>
    </div>
  </div>
</template>

<script>
import headTop from "./../../components/headTop";
import register from "./../../components/user/register";
export default {
  components: {
    headTop,
    register
  },
  data() {
    return {};
  },
  mounted(){
    var _this=this
  },

  methods: {}
};
</script>
<style lang="scss">
.register{
  .user-register{
    border-bottom: 1px solid #ffffff;
  }
}
</style>
<style lang='scss' scoped>
.register {
  background: url("./../../assets/img/pic_bg.png") no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  .main{
    height: calc(100vh - 350px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>